import type { ReactNode } from "react";

type SurfaceProps = {
  locale: string;
  direction: "rtl" | "ltr";
  kicker?: string;
  title: string;
  subtitle?: string;
  children: ReactNode;
};

export function Surface({
  locale,
  direction,
  kicker,
  title,
  subtitle,
  children,
}: SurfaceProps) {
  return (
    <main className="portal-surface" dir={direction} lang={locale}>
      <section className="portal-card">
        {kicker ? <div className="portal-kicker">{kicker}</div> : null}
        <h1 className="portal-title">{title}</h1>
        {subtitle ? <p className="portal-subtitle">{subtitle}</p> : null}
        <div className="portal-body">{children}</div>
      </section>
    </main>
  );
}
